export const FETCH_OVERVIEW_DATA_INIT = 'FETCH_CRM/OVERVIEW/DATA_INIT';
export const FETCH_OVERVIEW_DATA_SUCCESS = 'FETCH_CRM/OVERVIEW/DATA_SUCCESS';
export const FETCH_OVERVIEW_DATA_FAIL = 'FETCH_CRM/OVERVIEW/DATA_FAIL';